export var collectErrorMessages = function (value) {
    if (!value || typeof value !== "object")
        return [];
    var obj = value;
    if (typeof obj.message === "string")
        return [obj.message];
    return Object.entries(obj).flatMap(function (_a) {
        var key = _a[0], nested = _a[1];
        return key === "ref" ? [] : collectErrorMessages(nested);
    });
};
export var collectUniqueErrorMessages = function (errors) {
    var seen = new Set();
    return collectErrorMessages(errors).filter(function (message) {
        if (seen.has(message))
            return false;
        seen.add(message);
        return true;
    });
};
